module.exports = __webpack_public_path__ + "static/img/psa.13004fff.png";